import React from 'react'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import siteVars from '~/Classes/siteVars'
import Helpers from '~/Classes/helpers'
import CopyPasteIcon from '~/Common-Objects/UI/Forms/CopyPasteIcon/copyPasteIcon'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import i18n from '~/i18n'

export default function LandingPageDetails({ landingPage, url }) {
    return (
        <Paper className='paper-padding-24' style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <h4>Details</h4>
            <PageUrlDetail url={url} />
            <Detail
                icon='eye'
                label='Status'
                content={landingPage.status ? i18n.t('form:landingPages.live') : i18n.t('form:landingPages.draft')}
            />
            <Detail
                icon='calendar'
                label='Date Created'
                content={DateTimeFunctions.formatDateTime(landingPage.createdAt)}
            />
            <Detail
                icon='pencil'
                label='Last Modified'
                content={DateTimeFunctions.formatDateTime(landingPage.updatedAt)}
            />
        </Paper>
    )
}

function PageUrlDetail({ url }) {
    return (
        <Detail
            icon='world'
            label='Page URL'
            content={url}
            overlayCta
            // Go back to showing the address once the pointer leaves the row.
            cta={
                <>
                    <CopyPasteIcon
                        value={url}
                        showOnHover={true}
                        postHogTag='landing-page-overview-copy-url'
                        toolTipId='landing-page-overview-url-tooltip'
                    />
                </>
            }
        />
    )
}

function Detail({ icon, label, content, cta, overlayCta }) {
    return (
        <div
            // The parent class lets any icon inside show itself on hover.
            className='quickFlex show-on-hover-parent'
            style={{ gap: 16, position: 'relative' }}
        >
            <div style={{ flexGrow: 0 }}>
                <Icons
                    icon={icon}
                    outerStyle={{
                        borderRadius: 4,
                        backgroundColor: 'var(--indigo-50)',
                        height: 38,
                        width: 38,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    color='var(--indigo-600)'
                    style={{ height: 20, width: 20 }}
                />
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    whiteSpace: 'nowrap',
                    // Take up whatever room is left so long values like the URL get as
                    // much space as possible before being cut short.
                    flexGrow: 1,
                    minWidth: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
            >
                <div
                    style={{
                        color: 'var(--neutral-700)',
                        fontWeight: 400,
                        fontStyle: 'Regular',
                        fontSize: '13px',
                        lineHeight: '18px',
                        letterSpacing: '-0.13px'
                    }}
                >
                    {label}
                </div>
                <div
                    style={{
                        color: 'var(--neutral-950)',
                        fontWeight: 500,
                        fontStyle: 'Medium',
                        fontSize: '14px',
                        lineHeight: '20px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    {content}
                </div>
            </div>
            {!!cta && (
                <div
                    style={
                        // Sit on top of the row rather than taking up a column of its own,
                        // so the value beneath gets the full width of the card.
                        overlayCta
                            ? {
                                  position: 'absolute',
                                  right: 0,
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  display: 'flex',
                                  alignItems: 'center'
                              }
                            : { flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }
                    }
                >
                    {cta}
                </div>
            )}
        </div>
    )
}
